import uPlot from "uplot";
import UplotVue from "uplot-vue";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("UplotVue", UplotVue);
});
